import { apiService } from "./apiService";
import apiRoutes from "./apiRoutes";

// Login API
export const login = async (email, password) => {
  try {
    // console.log(apiRoutes.login, "apiRoutes.login")
    const response = await apiService.post(apiRoutes.login, {
      email,
      password,
    });
    localStorage.setItem("authToken", response.data.data.token);
    localStorage.setItem("authUser", JSON.stringify(response.data.data));
    return response.data;
  } catch (error) {
    throw new Error(error.message || "Login failed");
  }
};

// Send OTP API
export const sendOtp = async (email) => {
  try {
    const response = await apiService.post(apiRoutes.sendOtp, {
      email,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data.message || "Send OTP failed");
  }
};

export const getCms = async (payload) => {
  try {
    const response = await apiService.post(apiRoutes.getCms, payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error occurred in CMS fetch");
  }
};

// UPDATE CMS
export const updateCms = async (payload) => {
  try {
    const response = await apiService.post(apiRoutes.updateCms, payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error occurred in CMS update");
  }
};









